import { makeStyles } from "@material-ui/core/styles";
import {
  primary,
  secondary,
  error,
  success,
} from "../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  container: {
    borderBottom: `solid 4px ${primary}`,
    minHeight: 50,
  },
  bold: {
    fontWeight: "bold",
  },
  titleTypography: {
    marginBottom: theme.spacing(1),
  },
  highlightTypography: {
    marginBottom: theme.spacing(1),
  },
  captionTypography: {
    marginBottom: theme.spacing(2),
    "& svg": {
      color: ({ growthDirection }) =>
        growthDirection === "up" ? success : error,
      transform: ({ growthDirection }) =>
        growthDirection === "down" && "rotateZ(180deg)",
      width: theme.spacing(4),
    },
  },
  iconButton: {
    "& svg": {
      color: primary,
      width: theme.spacing(2),
    },
  },
  spinnerContainer: {
    minHeight: 85,
  },
  spinner: {
    color: secondary,
  },
}));

export default useStyles;
